/* Garden Glory lander — smooth-scroll for in-page anchors (e.g. the hero
   "Bundle and save" button). Reduced-motion users keep the instant jump. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.gg-lander [data-ggl-scroll]');
    if (!a) return;
    var target = document.querySelector(a.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });
})();

/* Garden Glory lander — scroll-reveal polish.
   Progressive enhancement: elements are only tagged .ggl-anim from here, so
   if this never runs (old browser, reduced motion) everything stays visible. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var root = document.querySelector('.gg-lander');
  if (!root) return;

  function init() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    /* per band, reveal a curated set of elements with a small stagger */
    var candidates = [
      '.ggl__pill', '.ggl__hero-title', '.ggl__hero-sub', '.ggl__price-row', '.ggl__cta-row', '.ggl__cta-notes',
      '.ggl__eyebrow', '.ggl__heading', '.ggl__moment', '.ggl__gallery', '.ggl__book-body',
      '.ggl__spec', '.ggl__fineprint', '.ggl__look-inside', '.ggl__gift', '.ggl__dealeasy',
      '.ggl__photo', '.ggl__photo-note',
      '.ggl__stars', '.ggl__trust-count', '.ggl__trust-sub', '.ggl__promises', '.ggl__quote',
      '.ggl__story-text', '.ggl__story-photo', '.ggl__story-feature-photo', '.ggl__story-feature-text', '.ggl__finale-hero', '.ggl__finale-photo', '.ggl__finale-text', '.ggl__logbase', '.ggl__card',
      '.ggl__final-heading', '.ggl__final-sub', '.ggl__final .ggl__buy'
    ].join(',');

    var bands = root.querySelectorAll('.ggl__hero-copy, section.ggl__band, section.ggl__final');
    bands.forEach(function (band) {
      var i = 0;
      band.querySelectorAll(candidates).forEach(function (el) {
        el.classList.add('ggl-anim');
        el.style.transitionDelay = Math.min(i * 80, 560) + 'ms';
        io.observe(el);
        i++;
      });
    });

    root.classList.add('gg-lander--animated');

    /* failsafe: if nothing has revealed after 8s the observer isn't doing its
       job in this environment — show everything rather than hide content */
    setTimeout(function () {
      if (!root.querySelector('.ggl-anim.is-in')) {
        root.querySelectorAll('.ggl-anim').forEach(function (el) { el.classList.add('is-in'); });
      }
    }, 8000);
  }

  /* background tabs: intersections don't compute while the document is
     hidden, so wait for first visibility to start the show */
  if (document.hidden) {
    document.addEventListener('visibilitychange', function onVis() {
      if (!document.hidden) {
        document.removeEventListener('visibilitychange', onVis);
        init();
      }
    });
  } else {
    init();
  }
})();
